import { connect } from "react-redux";
import get from "lodash/get";

import { getMapPositions as onGetMapPositions } from "../../actions/mapPositionsActions";
import { getMapParkingPositions as onGetMapParkingPositions } from "../../actions/mapParkingPositionsActions";
import { getMapOrigenalPositions as onGetMapOrigenalPositions } from "../../actions/mapOrigenalPositionsAction";
import { getMapFuelingPositions as onGetMapFuelingPositions } from "../../actions/mapFuelingPositionsActions";
import { getMapDrainPositions as onGetMapDrainPositions } from "../../actions/mapDrainPositionsActions";
import { getMapGpsJammingPositions as onGetMapGpsJammingPositions } from "../../actions/mapGpsJammingPositionsActions";
import { getSpeedingPoints as onGetSpeedingPoints } from "../../actions/mapSpeedingPointsActions";

const mapStateToProps = (state) => ({
  mapPositionsDataState: state.mapPositions.dataState,
  mapParkingsDataState: state.parkings.dataState.parkings,
  mapFuelingsDataState: state.fuelings.dataState.fuelings,
  mapDrainssDataState: state.drains.dataState.drains,
  mapGpsJamminDataState: state.gpsJammings.mapGpsJamminDataState,
  mapSpeedingPointsDataState: state.speedingPoints.mapSpeedingPointsDataState,
  mapOrigenalPositionsDataState: state.origenalPositions.dataState.parkings,
  mapPositionsData: get(state, ["mapPositions", "mapPositionsData"], []),
  mapPositionsCount: get(state, ["mapPositions", "mapPositionsCount"], []),
  carNumber: get(state, ["mapPositions", "carNumber"], []),
  mapRoute: get(state, ["mapPositions", "mapRoute"], []),
  mapRoutes: get(state, ["mapPositions", "mapRoutes"], []),
  sandRoutes: get(state, ["mapPositions", "sandRoutes"], []),
  dumpRoutes: get(state, ["mapPositions", "dumpRoutes"], []),
  dump2Routes: get(state, ["mapPositions", "dump2Routes"], []),
  mapPoints: get(state, ["mapPositions", "mapPoints"], []),
  mapPositionsErrors: get(state, ["mapPositions", "errors"], []),
  parkings: get(state, ["parkings", "parkings"], []),
  drains: get(state, ["drains", "drains"], []),
  fuelings: get(state, ["fuelings", "fuelings"], []),
  gpsJammings: get(state, ["gpsJammings", "gpsJammings"], []),
  speedingPoints: get(state, ["speedingPoints", "speedingPoints"], []),
  origenalPositions: get(state, ["origenalPositions", "origenalPositions"], []),
});

const mapDispatchToProps = {
  onGetMapPositions,
  onGetMapParkingPositions,
  onGetMapOrigenalPositions,
  onGetMapFuelingPositions,
  onGetMapDrainPositions,
  onGetMapGpsJammingPositions,
  onGetSpeedingPoints,
};

const withMapPositions = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withMapPositions };
